import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App.js';
import './styles/base.css';
import './styles/components.css';
import './styles/features.css';
import './styles/wallet-artwork.css';
import './styles/wallet-link-artwork.css';
import './styles/withdraw-artwork.css';
import './styles/toast-artwork.css';
import './styles/swap-artwork.css';
import './styles/notice-artwork.css';
import './styles/profile-artwork.css';
import './styles/miner-artwork.css';
import './styles/invite-artwork.css';
import './styles/home-artwork.css';
import './styles/nav-artwork.css';
import './styles/tasks-artwork.css';
import './styles/crew-artwork.css';
import './styles/activity-artwork.css';
import './styles/levelup-artwork.css';
import './styles/combo-artwork.css';
import './styles/roulette-artwork.css';
import './styles/ban-artwork.css';
import './assets/mine/mine.css';
import './styles/mining-artwork.css';

/*
 * GigaPub's test page (public/gigapub-test.html), for finding out why its ads
 * come from one network only: opened from Telegram with ?startapp=gigapubtest
 * — gigapubtest_6935 for another project, …_csp to keep the app's security
 * policy — it plays GigaPub on a bare page and lists everything GigaPub does.
 * Telegram's data goes along in the address, as Telegram sent it.
 */
const startParam =
  (window as unknown as { Telegram?: { WebApp?: { initDataUnsafe?: { start_param?: string } } } }).Telegram?.WebApp
    ?.initDataUnsafe?.start_param ?? new URLSearchParams(location.hash.slice(1)).get('tgWebAppStartParam') ?? '';
const gigapubTest = /^gigapubtest(?:_(\d{1,12}))?(_csp)?$/.exec(startParam);
/*
 * Adexium's test page (public/adexium-test.html), for finding out why its ads
 * do not show: opened with ?startapp=adexiumtest — …_debug for Adexium's test
 * ads, …_csp to keep the app's security policy — it makes Adexium's widget on
 * a bare page and lists everything it does and every answer it gets.
 */
const adexiumTest = /^adexiumtest(_debug)?(_csp)?$/.exec(startParam);
/*
 * USL's test page (public/usl-test.html), the same for USL's TowerAds SDK:
 * ?startapp=usltest (…_csp to keep the app's security policy).
 */
const uslTest = /^usltest(_csp)?$/.exec(startParam);

if (gigapubTest) {
  const query = new URLSearchParams({ id: gigapubTest[1] ?? '8720' });
  if (gigapubTest[2]) query.set('csp', 'app');
  location.replace(`/gigapub-test.html?${query.toString()}${location.hash}`);
} else if (adexiumTest) {
  const query = new URLSearchParams();
  if (adexiumTest[1]) query.set('debug', '1');
  if (adexiumTest[2]) query.set('csp', 'app');
  const search = query.toString();
  location.replace(`/adexium-test.html${search ? `?${search}` : ''}${location.hash}`);
} else if (uslTest) {
  location.replace(`/usl-test.html${uslTest[1] ? '?csp=app' : ''}${location.hash}`);
} else {
  const container = document.getElementById('root');
  if (!container) throw new Error('#root is missing from index.html');

  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
